const variants = {
  sage: 'text-mm-sage bg-mm-sage/10 border-mm-sage/25',
  persimmon: 'text-mm-persimmon bg-mm-persimmon/10 border-mm-persimmon/25',
  gold: 'text-mm-gold bg-mm-gold/10 border-mm-gold/25',
  viridian: 'text-mm-viridian bg-mm-viridian/10 border-mm-viridian/25',
  parchment: 'text-mm-parchment/50 bg-mm-parchment/5 border-mm-parchment/15',
}

export default function Badge({ children, variant = 'sage', className = '' }) {
  return (
    <span className={`text-[11px] px-2.5 py-0.5 rounded border tracking-wide ${variants[variant]} ${className}`}>
      {children}
    </span>
  )
}
